// src/routes/AppRoute.js
import React from "react";
import { Route, Redirect } from "react-router-dom";

// GET logged-in user from localStorage
const getAuthUser = () => {
  try {
    const user = localStorage.getItem("authUser");
    return user ? JSON.parse(user) : null;
  } catch (e) {
    return null;
  }
};

const AppRoute = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  requiredPermission, // <-- NEW
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      const user = getAuthUser();

      // 1️⃣ NOT LOGGED IN → redirect to login
      if (isAuthProtected && !user) {
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        );
      }

      // 2️⃣ If user is ADMIN → allow everything
      if (user?.userType === "ADMIN") {
        return (
          <Layout>
            <Component {...props} />
          </Layout>
        );
      }

      // 3️⃣ SUB_ADMIN → check permissions
      if (user?.userType === "SUB_ADMIN") {
        // If route requires permission & user does NOT have it → REDIRECT
        if (requiredPermission && !user.permissions?.includes(requiredPermission)) {
          return <Redirect to="/dashboard" />;
        }
      }

      // 4️⃣ Render normally
      return (
        <Layout>
          <Component {...props} />
        </Layout>
      );
    }}
  />
);

export default AppRoute;
